import React, { FunctionComponent, useEffect, useRef } from 'react'
import { FlexColumn, Input, InputLabel, InputSubLabel } from '../../styled'
import { useRatingTemplate } from '../../hooks/useRatingTemplate'
import { RatingHole } from '../../hooks/useRatingTemplate/types'

function compressRun(run: number[]): string {
  if (run.length === 1) return String(run[0])
  return `${run[0]}-${run[run.length - 1]}`
}

function suggestCourseName(ratingHoles: RatingHole[]): string {
  const filled = ratingHoles.filter(
    (h) => h.physicalID && h.courseHoleNumber != null && h.courseName
  )
  if (filled.length === 0) return ''

  const courseOrder: string[] = []
  const holesByCourseName: Record<string, number[]> = {}

  filled.forEach((h) => {
    const name = h.courseName!
    if (!holesByCourseName[name]) {
      holesByCourseName[name] = []
      courseOrder.push(name)
    }
    holesByCourseName[name].push(h.courseHoleNumber!)
  })

  const isSingleCourse = courseOrder.length === 1

  const parts = courseOrder.map((courseName) => {
    const nums = holesByCourseName[courseName]
    const runs: number[][] = [[nums[0]]]
    for (let i = 1; i < nums.length; i++) {
      const diff = nums[i] - nums[i - 1]
      if (diff === 1 || diff === -1) {
        runs[runs.length - 1].push(nums[i])
      } else {
        runs.push([nums[i]])
      }
    }
    const holeStr = runs.map(compressRun).join(' + ')
    return isSingleCourse ? holeStr : `${courseName} ${holeStr}`
  })

  return parts.join(', ')
}

const CourseNameInput: FunctionComponent<{ sublabel?: string }> = ({
  sublabel,
}) => {
  const { ratingHoles, holes, courseName, setCourseName } = useRatingTemplate()
  const manuallyEditedRef = useRef(false)

  const allFilled =
    ratingHoles.length === holes && ratingHoles.every((h) => h.physicalID)

  useEffect(() => {
    if (manuallyEditedRef.current) return
    if (allFilled) {
      const suggestion = suggestCourseName(ratingHoles)
      if (suggestion) {
        setCourseName(suggestion)
      }
    } else {
      setCourseName('')
    }
  }, [allFilled, ratingHoles])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    manuallyEditedRef.current = true
    setCourseName(e.target.value)
  }

  return (
    <FlexColumn>
      <InputLabel showSubLabel={!!sublabel}>Course name</InputLabel>
      <InputSubLabel>{sublabel}</InputSubLabel>
      <Input
        placeholder="Type here"
        value={courseName}
        onChange={handleChange}
      />
    </FlexColumn>
  )
}

export default CourseNameInput
